<template>
  <div class="my-address">
    <!-- 顶部标题 -->
    <div ref="addressHeader" class="hande">
      <div class="titile">{{ $t('我的收货地址') }}</div>
      <div class="rightbtn" @click="openAddAddress">
        <i class="el-icon-plus"></i>
        <span>{{ $t('添加地址') }}</span>
      </div>
    </div>
    <!-- PC 表格 -->
    <div v-if="!isH5">
      <el-table ref="addressTable" :data="tableData" style="width: 100%">
        <el-table-column :label="$t('收货人')" header-align="center" align="center">
          <template slot-scope="scope">
            <div class="tableflex">
              <div class="left" v-if="scope.row.is_default">{{ $t('默认') }}</div>
              <div style="margin-left: 10px">{{ scope.row.consignee }}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="mobile" align="center" :label="$t('电话/手机')" header-align="center" />
        <!-- <el-table-column prop="address" label="所在地区" align="center" header-align="center" /> -->
        <el-table-column :label="$t('所在地区')" header-align="center" align="center">
          <template slot-scope="scope">
            <div class="">
              <span>{{ scope.row.province_name }}</span>
              <span>{{ scope.row.city_name }}</span>
              <span>{{ scope.row.district_name }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="address" :label="$t('详细地址')" align="center" header-align="center" />
        <el-table-column :label="$t('操作')" header-align="center">
          <template slot-scope="scope">
            <div class="operate">
              <div class="flex_around">
                <div class="left" @click="handleEdit(scope.$index, scope.row)">
                  {{ $t('修改') }}
                </div>
                <div class="Divider"></div>
                <div class="right" @click="dialogVisible = true, handleDeleteId = scope.row.id">
                  {{ $t('删除') }}
                </div>
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- H5 地址卡片 -->
    <div class="h5-address-list" v-if="isH5">
      <div ref="addressCard" class="h5-address-card" v-for="(row, index) in tableData" :key="row.id || index">
        <div class="h5-address-head">
          <div class="h5-address-user">
            <span class="default-tag" v-if="row.is_default">{{ $t('默认') }}</span>
            <span class="consignee">{{ row.consignee }}</span>
          </div>
          <span class="mobile">{{ row.mobile }}</span>
        </div>
        <div class="h5-address-region">
          {{ row.province_name }} {{ row.city_name }} {{ row.district_name }}
        </div>
        <div class="h5-address-detail">{{ row.address }}</div>
        <div class="h5-address-actions">
          <div class="action-edit" @click="handleEdit(index, row)">{{ $t('修改') }}</div>
          <div class="action-divider"></div>
          <div class="action-delete" @click="openDeleteDialog(row.id)">{{ $t('删除') }}</div>
        </div>
      </div>
      <div class="h5-empty" v-if="!tableData.length">{{ $t('暂无收货地址') }}</div>
    </div>

    <!-- 添加地址 start-->
    <transition :name="isH5 ? 'address-pop-h5' : ''">
      <div class="pop address-pop" :class="{ 'is-h5': isH5 }" v-if="add_address" @click.self="closeAddAddress">
        <div class="pop-box address-pop-box" @click.stop>
          <div class="box-tit">
            <span class="box-tit-text" v-if="isH5">{{ is_xiugai ? $t('修改地址') : $t('添加地址') }}</span>
            <span v-else></span>
            <i class="el-icon-close" @click="closeAddAddress"></i>
          </div>
          <div class="address-pop-body">
            <div class="box-ipt">
              <div class="box-ipt-tit">{{ $t('地址信息') }}</div>
              <el-cascader v-model="value" :props="props" @change="handleChange" :placeholder="$t('请选择省市区')"></el-cascader>
            </div>
            <div class="box-ipt">
              <div class="box-ipt-tit">{{ $t('详细地址') }}</div>
              <textarea :placeholder="$t('请输入详细地址')" v-model="site_data.address"></textarea>
            </div>
            <div class="box-ipt">
              <div class="box-ipt-tit">{{ $t('收货人姓名') }}</div>
              <input type="text" :placeholder="$t('请输入收货人姓名')" v-model="site_data.consignee">
            </div>
            <div class="box-ipt">
              <div class="box-ipt-tit">{{ $t('手机号码') }}</div>
              <div class="ipt-ipt">
                <el-dropdown @command="prefixHandleCommand" class="ipt-prefix">
                  <span class="el-dropdown-link">
                    +{{ prefix }}<i class="el-icon-arrow-down el-icon--right"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item :command="item.name" v-for="(item, index) in prefix_list" :key="index">
                      {{ item.name }}
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
                <input type="tel" :placeholder="$t('请输入手机号码')" class="ipt-ipt-input" v-model="site_data.mobile">
              </div>
            </div>
            <el-checkbox v-model="checked" class="default-checkbox">{{ $t('设置为默认收货地址') }}</el-checkbox>
          </div>
          <div class="address-pop-footer">
            <div class="box-btn" @click="onAddSite">{{ is_xiugai ? $t('修改') : $t('保存') }}</div>
          </div>
        </div>
      </div>
    </transition>
    <!-- 添加地址 end -->

    <el-dialog :title="$t('提示')" :visible.sync="dialogVisible" :width="isH5 ? '90%' : '30%'"
      :custom-class="isH5 ? 'h5-address-dialog' : ''">
      <span>{{ $t('确认删除此收货地址吗') }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">{{ $t('取消') }}</el-button>
        <el-button type="primary" @click="handleDelete">{{ $t('确定') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<style scoped>
div /deep/ .el-table__header-wrapper th {
  background: #f8f8f8;
  /* 背景色 */
  font-family: Microsoft YaHei, Microsoft YaHei;
  font-weight: 400;
  font-size: 16px;
  color: #333333;
}

.el-cascader {
  width: 100%;
}

.address-pop /deep/ .el-cascader .el-input__inner {
  height: 48px;
  line-height: 48px;
}
</style>

<style lang="scss">
.h5-address-dialog {
  max-width: 360px;
  border-radius: 8px;
}

.address-pop-h5-enter-active,
.address-pop-h5-leave-active {
  transition: opacity 0.28s ease;

  .address-pop-box {
    transition: transform 0.28s ease;
  }
}

.address-pop-h5-enter,
.address-pop-h5-leave-to {
  opacity: 0;

  .address-pop-box {
    transform: translateY(100%);
  }
}
</style>

<script>
import { siteList, addSite, cityLinkage, deleteCity, cityDetail, cityAmend, phonePrefix } from '@/api/user';
let id = 0;

export default {
  name: "Receivingaddress",
  data() {
    return {
      tableData: [],//地址列表
      add_address: false,//添加或修改地址弹窗
      checked: false,//是否为默认
      site_data: {
        consignee: '',//收货人姓名
        mobile: '',//收货人联系方式
        address: '',//详细地址
        province_id: '',//省份ID
        city_id: '',//城市ID
        district_id: '',//地区ID
        province_name: '',//省份名称
        city_name: '',//城市名称
        district_name: '',//区名称
        street_id: '0'
      },//添加地址内容
      props: {
        lazy: true,
        lazyLoad(node, resolve) {
          let pid = node.value || 0

          let options = []
          let data = {
            pid: pid,
            type: 1
          }
          // console.log(node);

          cityLinkage(data).then(res => {
            let list = res.data
            list.forEach(e => {
              for (let i in e.data) {
                options.push(e.data[i])
                e.data[i].leaf = node.level == 2
              }
            })
            // 通过调用resolve将子节点数据返回，通知组件数据加载完成
            resolve(options);
          })
        }
      },//地址列表
      dialogVisible: false,//确认删除弹窗
      handleDeleteId: '',//删除的id
      value: [],//地址
      is_xiugai: false,//是否为修改
      id: '',//地址id
      prefix_list: [],//前缀列表
      prefix: '',//前缀
      isH5: typeof window !== 'undefined' && window.innerWidth < 768,
      // 收货地址页面入场动画实例，用于组件销毁时释放动画资源
      addressEntranceAnimation: null,
    };
  },
  mounted() {
    this.onSiteList()
    this.onPhonePrefix();
    this.updateIsH5();
    window.addEventListener('resize', this.updateIsH5);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateIsH5);
    if (this.addressEntranceAnimation) {
      this.addressEntranceAnimation.progress(1).kill();
    }
  },
  methods: {
    /** 播放收货地址列表的入场动效 */
    playAddressEntranceAnimation() {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        return;
      }
      if (this.addressEntranceAnimation) {
        this.addressEntranceAnimation.progress(1).kill();
      }
      const addressContent = this.isH5
        ? (this.$refs.addressCard || [])
        : [this.$refs.addressTable && this.$refs.addressTable.$el];
      const targets = [this.$refs.addressHeader].concat(addressContent).filter(Boolean);
      this.addressEntranceAnimation = this.$gsap.fromTo(targets, {
        y: 16,
        opacity: 0,
      }, {
        y: 0,
        opacity: 1,
        duration: 0.45,
        stagger: 0.08,
        ease: 'power2.out',
        onComplete: () => {
          this.$gsap.set(targets, { clearProps: 'opacity,transform' });
        },
      });
    },
    updateIsH5() {
      this.isH5 = window.innerWidth < 768;
    },
    openAddAddress() {
      this.add_address = true;
      this.is_xiugai = false;
    },
    closeAddAddress() {
      this.add_address = false;
    },
    openDeleteDialog(id) {
      this.dialogVisible = true;
      this.handleDeleteId = id;
    },
    /**前缀切换 */
    prefixHandleCommand(e) {
      // console.log(e);
      this.prefix = e
    },
    /**手机号前缀 */
    onPhonePrefix() {
      phonePrefix().then(res => {
        this.prefix_list = res.data
        this.prefix = this.prefix_list[0].name
        console.log(res.data);
      })
    },
    /**地址选中 */
    handleChange(value) {
      // console.log(value);
      this.site_data.province_id = value[0]
      this.site_data.city_id = value[1]
      this.site_data.district_id = value[2]
      for (let i = 0; i < 3; i++) {
        this.onCityLinkage(i)
      }
    },
    /**城市联动 */
    onCityLinkage(i) {
      let data = {
        type: 1
      }

      if (i == 0) {
        data.pid = 0
      } else if (i == 1) {
        data.pid = this.site_data.province_id
      } else if (i == 2) {
        data.pid = this.site_data.city_id
      }

      cityLinkage(data).then(res => {
        let list = res.data
        list.forEach(e => {
          for (let j in e.data) {
            if (e.data[j].value == this.site_data.province_id) {
              this.site_data.province_name = e.data[j].label
            }
            if (e.data[j].value == this.site_data.city_id) {
              this.site_data.city_name = e.data[j].label
            }
            if (e.data[j].value == this.site_data.district_id) {
              this.site_data.district_name = e.data[j].label
            }
          }
        })
      })
    },
    /**添加地址 */
    onAddSite() {
      this.site_data.is_default = Number(this.checked)
      if (!this.site_data.province_id) {
        this.$message.warning(this.$t('请选择地址'));
        return
      }
      if (!this.site_data.address) {
        this.$message.warning(this.$t('请输入详细地址'));
        return
      }
      if (!this.site_data.consignee) {
        this.$message.warning(this.$t('请输入收货人姓名'));
        return
      }
      if (!this.site_data.mobile) {
        this.$message.warning(this.$t('请输入手机号'));
        return
      }

      if (this.is_xiugai = true) {
        this.site_data.id = this.id
        cityAmend(this.site_data).then(res => {
          if (res.code == 1) {
            this.$message.success(this.$t('地址修改完毕'));
            this.onSiteList()
            this.add_address = false
          } else {
            this.$message.warning(res.msg);
          }
        })
      } else {
        addSite(this.site_data).then(res => {
          if (res.code == 1) {
            this.$message.success(this.$t('地址添加完毕'));
            this.onSiteList()
            this.add_address = false
          } else {
            this.$message.warning(res.msg);
          }
        })
      }
    },
    /**地址列表 */
    onSiteList() {
      siteList().then(res => {
        console.log(res.data);
        this.tableData = res.data
        this.$nextTick(() => {
          this.playAddressEntranceAnimation();
        });
      })
    },
    /**修改 */
    handleEdit(index, row) {
      // console.log(index, row);
      cityDetail({ id: row.id }).then(res => {
        console.log(res.data);
        let data = res.data
        let site_data = {
          consignee: data.consignee,//收货人姓名
          mobile: data.mobile,//收货人联系方式
          address: data.address,//详细地址
          province_id: data.province_id,//省份ID
          city_id: data.city_id,//城市ID
          district_id: data.district_id,//地区ID
          province_name: data.province_name,//省份名称
          city_name: data.city_name,//城市名称
          district_name: data.district_name,//区名称
          street_id: '0'
        }

        this.add_address = true

        this.id = row.id
        this.is_xiugai = true
        this.checked = data.is_default == 1
        this.site_data = site_data
        let value = []
        value.push(data.province_id)
        value.push(data.city_id)
        value.push(data.district_id)
        this.value = value
      })
    },
    /**删除 */
    handleDelete() {
      deleteCity({ id: this.handleDeleteId }).then(res => {
        if (res.code == 1) {
          this.$message.success(this.$t('地址已删除'));
          this.dialogVisible = false
          this.onSiteList()
        } else {
          this.$message.warning(res.msg);
        }
      })
    },
  },
};
</script>

<style scoped lang="scss">
.my-address {
  width: 1060rpx;
  height: 80vh;
  background: #ffffff;
  border-radius: 8px 8px 8px 8px;
  padding: 16px;
  box-shadow: 0px 3px 16px 0px rgba(0, 0, 0, 0.2);
  margin: 12px;
  box-sizing: border-box;

  .hande {
    display: flex;
    align-content: center;
    justify-content: space-between;
    margin-bottom: 20px;

    .titile {
      font-family: Microsoft YaHei, Microsoft YaHei;
      font-weight: bold;
      font-size: 20px;
      color: #333333;
    }

    .rightbtn {
      font-size: 16px;
      color: #000000;
      cursor: pointer;
    }
  }

  .tableflex {
    display: flex;
    align-items: center;

    .left {
      padding: 2px 10px;
      background-color: #f5f5f5;
      color: #000000;
      font-size: 12px;
      border-radius: 4px;
      line-height: 20px;
    }
  }

  .operate {
    display: flex;
    align-items: center;
    justify-content: space-around;
    font-family: Microsoft YaHei, Microsoft YaHei;
    font-weight: 400;
    font-size: 14px;
    color: #333333;

    .left {
      cursor: pointer;
    }

    .right {
      cursor: pointer;
    }

    .Divider {
      height: 10px;
      border-right: 1px solid #333333;
      margin: 0 10px;
    }
  }
}

/**添加或修改地址弹窗*/
.pop {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  /* background-color: rgba($color: #000000, $alpha: 0.5); */
  background-color: rgba(0,0,0,0.5);
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;

  .pop-box {
    padding: 32px 24px;
    background: #FFFFFF;
    border-radius: 8px;
    width: 528px;
  }
}

.box-tit {
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;

  .box-tit-text {
    font-size: 20px;
    font-weight: 600;
  }

  span {
    font-size: 20px;
    font-weight: 600;
  }

  i {
    font-size: 20px;
    cursor: pointer;
  }
}

.default-checkbox {
  margin-top: 20px;
}

.ipt-prefix {
  width: 50px;
  flex-shrink: 0;
  cursor: pointer;
}

.address-pop-footer {
  .box-btn {
    margin-top: 48px;
  }
}

.box-ipt {
  margin-top: 24px;
  font-size: 14px;

  .box-ipt-tit {
    margin-bottom: 10px;
    font-size: 16px;
  }

  .ipt-box {
    width: 100%;
    border: 1px solid #EEEEEE;
    border-radius: 4px;
    padding: 14px 12px;
    box-sizing: border-box;
    cursor: pointer;
    display: flex;
    justify-content: space-between;
  }

  textarea {
    width: 100%;
    height: 96px;
    padding: 12px;
    box-sizing: border-box;
    border: 1px solid #EEEEEE;
    border-radius: 4px;
    resize: none;
  }

  input {
    width: 100%;
    height: 48px;
    padding: 12px;
    box-sizing: border-box;
    border: 1px solid #EEEEEE;
    border-radius: 4px;
  }

  .ipt-ipt {
    width: 100%;
    /* // height: 48px; */
    padding: 12px;
    box-sizing: border-box;
    border: 1px solid #EEEEEE;
    border-radius: 4px;
    display: flex;

    .ipt-ipt-box {
      cursor: pointer;
    }

    .ipt-ipt-input {
      width: calc(100% - 70px);
      padding: 0;
      height: 100%;
      border: 0;
    }
  }
}

.box-btn {
  width: 100%;
  height: 48px;
  background: #000000;
  border-radius: 4px;
  color: #FFFFFF;
  text-align: center;
  line-height: 48px;
  font-size: 18px;
  margin-top: 48px;
  cursor: pointer;
}

.h5-address-list {
  display: none;
}

@media (max-width: 767px) {
  .my-address {
    width: 100%;
    height: auto;
    min-height: 0;
    margin: 0 !important;
    padding: 16px 12px 24px;
    box-sizing: border-box;
    overflow: visible;
    box-shadow: none;
    border-radius: 0;
    background: transparent;
  }

  .hande {
    margin-bottom: 12px;
    align-items: center;

    .titile {
      font-size: 16px;
    }

    .rightbtn {
      font-size: 14px;
      flex-shrink: 0;
    }
  }

  .h5-address-list {
    display: block;
  }

  .h5-address-card {
    background: #fff;
    border-radius: 8px;
    padding: 14px 12px;
    margin-bottom: 12px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
    box-sizing: border-box;
  }

  .h5-address-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    margin-bottom: 10px;
  }

  .h5-address-user {
    display: flex;
    align-items: center;
    gap: 8px;
    min-width: 0;

    .consignee {
      font-size: 16px;
      font-weight: 600;
      color: #333;
    }
  }

  .default-tag {
    flex-shrink: 0;
    padding: 2px 8px;
    background-color: #f5f5f5;
    color: #000000;
    font-size: 12px;
    border-radius: 4px;
    line-height: 20px;
  }

  .mobile {
    flex-shrink: 0;
    font-size: 14px;
    color: #333;
  }

  .h5-address-region {
    font-size: 14px;
    color: #666;
    line-height: 1.5;
    margin-bottom: 6px;
  }

  .h5-address-detail {
    font-size: 14px;
    color: #333;
    line-height: 1.5;
    word-break: break-all;
    margin-bottom: 12px;
  }

  .h5-address-actions {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding-top: 12px;
    border-top: 1px solid #eee;
    font-size: 14px;
    color: #333;

    .action-edit,
    .action-delete {
      cursor: pointer;
      padding: 4px 8px;
    }

    .action-divider {
      width: 1px;
      height: 12px;
      background: #ccc;
      margin: 0 4px;
    }
  }

  .h5-empty {
    text-align: center;
    padding: 48px 0;
    font-size: 14px;
    color: #999;
    background: #fff;
    border-radius: 8px;
  }

  .pop {
    align-items: flex-end;
    padding: 0;
    z-index: 2000;
  }

  .address-pop.is-h5 {
    .address-pop-box {
      display: flex;
      flex-direction: column;
      width: 100% !important;
      max-width: 100% !important;
      max-height: 90vh;
      padding: 0;
      border-radius: 16px 16px 0 0;
      overflow: hidden;
    }

    .box-tit {
      flex-shrink: 0;
      padding: 20px 16px 14px;
      border-bottom: 1px solid #f0f0f0;

      &::before {
        content: '';
        position: absolute;
        top: 8px;
        left: 50%;
        transform: translateX(-50%);
        width: 36px;
        height: 4px;
        background: #e5e5e5;
        border-radius: 2px;
      }

      .box-tit-text {
        font-size: 17px;
        font-weight: 600;
        color: #333;
      }

      i {
        font-size: 22px;
        color: #999;
        padding: 4px;
      }
    }

    .address-pop-body {
      flex: 1;
      overflow-y: auto;
      padding: 16px 16px 8px;
      -webkit-overflow-scrolling: touch;
    }

    .address-pop-footer {
      flex-shrink: 0;
      padding: 12px 16px calc(12px + env(safe-area-inset-bottom, 0px));
      border-top: 1px solid #f0f0f0;
      background: #fff;
      box-shadow: 0 -4px 16px rgba(0, 0, 0, 0.06);

      .box-btn {
        margin-top: 0;
        height: 44px;
        line-height: 44px;
        font-size: 16px;
        border-radius: 8px;
      }
    }

    .box-ipt {
      margin-top: 0;
      margin-bottom: 16px;

      &:last-of-type {
        margin-bottom: 0;
      }

      .box-ipt-tit {
        margin-bottom: 8px;
        font-size: 14px;
        color: #666;
      }

      textarea,
      input,
      .ipt-ipt-input {
        font-size: 16px;
      }

      textarea {
        height: 88px;
        border-color: #e8e8e8;
      }

      input {
        height: 44px;
        border-color: #e8e8e8;
      }

      .ipt-ipt {
        align-items: center;
        min-height: 44px;
        border-color: #e8e8e8;
      }
    }

    .default-checkbox {
      margin-top: 16px;
      display: flex;
      align-items: center;
    }

    /deep/ .el-cascader {
      width: 100%;
    }

    /deep/ .el-cascader .el-input__inner {
      height: 44px;
      line-height: 44px;
      font-size: 16px;
      border-color: #e8e8e8;
    }

    /deep/ .el-checkbox__label {
      font-size: 14px;
      color: #333;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/my/components/Receivingaddress.vue